<template>
    <div class="x-field">
        <div class="x-switch-left" :class="{'dense': isDense}">
            <el-switch :value="value"
                       :active-text="activeText"
                       :inactive-text="inactiveText"
                       :disabled="disable"
                       @input="handleInput($event)"></el-switch>
            <label class="x-label" style="margin-left: 8px">{{ label }}
                <el-tooltip class="item" effect="dark" placement="top-start" v-if="hasTooltip">
                    <i class="fa fa-info-circle"></i>
                    <div slot="content" v-html="tooltipText"></div>
                </el-tooltip>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'XSwitchLeft',
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            default: ''
        },
        disable: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        activeText: {
            type: String,
            default: '',
        },
        inactiveText: {
            type: String,
            default: '',
        },
        error: {
            default: null,
        },
        hasTooltip: {
            type: Boolean,
            default: false
        },
        tooltipText: {
            type: String,
            default: '',
        },
        isDense: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
    }
}
</script>
